import React, { useMemo, useState } from "react";
import { Drawer, Typography, Stack } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InfoRow from "../../../../components/atoms/InfoRow";
import FormTextField from "../../../../components/atoms/FormTextField";
import DrawerHeader from "../../../../components/atoms/DrawerHeader";
import DrawerFooter from "../../../../components/atoms/DrawerFooter";
import { COLORS, TYPO } from "../../../../styles/uiConstants";

export default function BillUploadDrawer({ open, onClose, clinic, onSubmit, isLoading }) {
  const [amount, setAmount] = useState("");
  const [firmApellation, setFirmApellation] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [reason, setReason] = useState("");

  const totalIncome = useMemo(() => {
    const a = Number(amount);
    const p = Number(unitPrice);
    if (!a || !p) return null;
    return a * p;
  }, [amount, unitPrice]);

  const canSubmit = Number(amount) > 0 && firmApellation.trim();

  const handleSubmit = () => {
    onSubmit({
      amount: Number(amount),
      firmApellation: firmApellation.trim(),
      unitPrice: unitPrice ? Number(unitPrice) : undefined,
      reason: reason.trim() || undefined,
    });
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 480 } } }}
    >
      <DrawerHeader
        icon={<ReceiptLongIcon />}
        title="Fatura ile Token Yükle"
        subtitle={clinic?.name}
        onClose={onClose}
        bgcolor={COLORS.successDark}
      />

      <Stack spacing={0} sx={{ p: 0, flex: 1, overflowY: "auto" }}>
        <InfoRow label="Miktar (token)">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            type="number"
            fullWidth
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputProps={{ min: 1 }}
          />
        </InfoRow>
        <InfoRow label="Fatura No">
          <Typography sx={{ fontSize: TYPO.body, color: "text.secondary", fontStyle: "italic" }}>
            Kayıt sırasında otomatik atanır
          </Typography>
        </InfoRow>
        <InfoRow label="Firma Ünvanı">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            fullWidth
            value={firmApellation}
            onChange={(e) => setFirmApellation(e.target.value)}
            inputProps={{ maxLength: 200 }}
          />
        </InfoRow>
        <InfoRow label="Birim Fiyat (₺)">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            type="number"
            value={unitPrice}
            onChange={(e) => setUnitPrice(e.target.value)}
            inputProps={{ min: 0, step: "0.01" }}
          />
        </InfoRow>
        {totalIncome !== null && (
          <InfoRow label="Toplam Gelir (₺)">
            <Typography sx={{ fontSize: TYPO.body, fontWeight: 600 }}>
              {totalIncome.toLocaleString("tr-TR", { minimumFractionDigits: 2 })}
            </Typography>
          </InfoRow>
        )}
        <InfoRow label="Not">
          <FormTextField
            variant="standard"
            InputProps={{ sx: { fontSize: TYPO.body } }}
            multiline
            fullWidth
            rows={2}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            inputProps={{ maxLength: 500 }}
          />
        </InfoRow>
      </Stack>

      <DrawerFooter
        onCancel={onClose}
        onSubmit={handleSubmit}
        submitLabel="Fatura Yükle"
        loading={isLoading}
        disabled={!canSubmit}
        submitColor="primary"
        fullWidth
      />
    </Drawer>
  );
}
